import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import HomeVideo2 from '../../assets/images/banner/banner-1.mp4';

const benefits = [
    ['education.png', 'A culture of learning', 'Work with curious people who share knowledge, welcome new perspectives and keep improving together.'],
    ['globe.png', 'Flexible working', 'Collaborate with our UAE-based team through a flexible environment designed for focused, connected work.'],
    ['build.png', 'Meaningful impact', 'Build practical security solutions that help organisations protect their people, systems and customers.'],
    ['collaboration.png', 'One collaborative team', 'Solve ambitious problems alongside supportive specialists who value trust, ownership and open communication.'],
    ['think.png', 'Long-term growth', 'Take responsibility for important work while developing your skills through challenges, feedback and mentorship.'],
    ['benifit.png', 'Competitive benefits', 'Receive a competitive package, time to recharge and support designed around your professional wellbeing.']
];

const openings = [
    {
        title: 'Presales Manager – Cybersecurity',
        experience: '3+ years',
        type: 'Full time',
        description: 'Translate complex cybersecurity requirements into clear, valuable solutions for enterprise customers.',
        skills: ['Lead technical discovery and solution presentations', 'Create proposals and support proof-of-concept engagements', 'Partner with sales, delivery and technology teams']
    },
    {
        title: 'IT Engineer',
        experience: '3+ years',
        type: 'Full time',
        description: 'Support secure, reliable IT environments and deliver an excellent technical experience to our customers.',
        skills: ['Configure and troubleshoot infrastructure and endpoints', 'Monitor systems and resolve technical incidents', 'Maintain clear documentation and security standards']
    },
    {
        title: 'Sales Lead',
        experience: '2+ years',
        type: 'Full time',
        description: 'Build trusted customer relationships and help organisations choose security solutions aligned with their goals.',
        skills: ['Develop qualified opportunities and manage the sales cycle', 'Understand customer priorities and communicate value', 'Collaborate with presales and delivery specialists']
    }
];

export default function Career() {
    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = 'Careers at CloudMind';
    }, []);

    return (
        <main className="career-page">
            <section className="career-hero">
                <video className="career-hero-video" autoPlay loop muted playsInline aria-hidden="true">
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
                <div className="career-hero-video-overlay"></div>
                <div className="career-hero-glow"></div>
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-8">
                            <div className="career-hero-content">
                                <span className="career-eyebrow">Careers at CloudMind</span>
                                <h1>Do meaningful work with people who care.</h1>
                                <p>Join a team of problem-solvers building a safer digital future for organisations across the region.</p>
                                <div className="career-hero-actions">
                                    <a href="#open-roles" className="career-primary-btn">Explore open roles <i className="fa fa-arrow-down" aria-hidden="true"></i></a>
                                    <Link to="/about" className="career-text-link">Meet CloudMind <i className="fa fa-arrow-right" aria-hidden="true"></i></Link>
                                </div>
                                <div className="career-hero-points">
                                    <span><i className="fa fa-check" aria-hidden="true"></i> UAE-based team</span>
                                    <span><i className="fa fa-check" aria-hidden="true"></i> Growth-focused culture</span>
                                    <span><i className="fa fa-check" aria-hidden="true"></i> Real customer impact</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="career-intro">
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6">
                            <div className="career-intro-image"><img src={require('../../assets/images/compnay/career-ban.webp')} alt="CloudMind professionals collaborating" /></div>
                        </div>
                        <div className="col-lg-6">
                            <div className="career-section-copy">
                                <span className="career-eyebrow">Why CloudMind</span>
                                <h2>Your ideas can make digital business safer.</h2>
                                <p>Cybersecurity changes every day, and we believe the best answers come from teams with different experiences and a shared desire to learn. Here, your voice matters and your work reaches real customers.</p>
                                <p>We give people the trust, context and support they need to take ownership—then celebrate what we achieve together.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="career-benefits-section">
                <div className="container">
                    <div className="career-section-heading">
                        <span className="career-eyebrow">Life at CloudMind</span>
                        <h2>Everything you need to do your best work.</h2>
                        <p>A thoughtful environment built around learning, collaboration and sustainable growth.</p>
                    </div>
                    <div className="row g-4">
                        {benefits.map(([icon, title, text]) => (
                            <div className="col-lg-4 col-md-6" key={title}>
                                <div className="career-benefit-card">
                                    <div className="career-benefit-icon"><img src={require(`../../assets/images/compnay/${icon}`)} alt="" /></div>
                                    <h3>{title}</h3>
                                    <p>{text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section id="open-roles" className="career-jobs-section">
                <div className="container">
                    <div className="career-jobs-header">
                        <div><span className="career-eyebrow">Open positions</span><h2>Find your next opportunity.</h2></div>
                        <p>Can’t find the right role? Send your profile to <a href="mailto:sales@cloudmindme.com">sales@cloudmindme.com</a>.</p>
                    </div>
                    <div className="career-job-list">
                        {openings.map((job, index) => (
                            <details className="career-job-card" key={job.title} open={index === 0}>
                                <summary>
                                    <div className="career-job-main"><h3>{job.title}</h3><p>{job.description}</p></div>
                                    <div className="career-job-meta"><span><i className="fa fa-map-marker" aria-hidden="true"></i> Dubai, UAE</span><span>{job.type}</span><span>{job.experience}</span></div>
                                    <span className="career-job-toggle"><i className="fa fa-plus" aria-hidden="true"></i></span>
                                </summary>
                                <div className="career-job-details">
                                    <div><h4>What you’ll do</h4><ul>{job.skills.map(skill => <li key={skill}>{skill}</li>)}</ul></div>
                                    <a href={`mailto:sales@cloudmindme.com?subject=Application for ${encodeURIComponent(job.title)}`} className="career-primary-btn">Apply for this role <i className="fa fa-arrow-right" aria-hidden="true"></i></a>
                                </div>
                            </details>
                        ))}
                    </div>
                </div>
            </section>

            <section className="career-final-cta">
                <div className="container">
                    <div className="career-final-inner">
                        <span className="career-eyebrow">Grow with us</span>
                        <h2>Great work starts with great people.</h2>
                        <p>Bring your curiosity, experience and ambition. Let’s build what comes next—together.</p>
                        <a href="mailto:sales@cloudmindme.com?subject=Career enquiry at CloudMind" className="career-primary-btn">Start a conversation <i className="fa fa-arrow-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </section>
        </main>
    );
}
